/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useSelector, useDispatch } from "react-redux";

// material-ui
import makeStyles from "@material-ui/styles/makeStyles";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import { CardContent, Divider } from "@material-ui/core";

//icon
import SaveIcon from "@material-ui/icons/Save";

// jazasoft
import {
  TextInput,
  NumberInput,
  SelectInput,
  PageFooter,
  PageHeader,
  Button,
  WithReduxForm,
  BackButton,
  showNotification,
  translate
} from "jazasoft";

// local
import Forbidden from "../../../components/Forbidden";
import CardHeader from "../../../components/CardHeader";
import MuiTable from "../../../components/MuiTable";

// helper
import { AlertParameterFields } from "../../../utils/entityFields";
// import SettingKeys from "../../../utils/SettingKeys";
import getValidation from "../../../utils/getValidation";
import { inputOptions } from "../../../utils/helpers";

import useMutation from "../../../hooks/useMutation";
// import useSetting from "../../../hooks/useSetting";
import useDeepMemo from "../../../hooks/useDeepMemo";
import { AlertParameterImpact, AlertParemeter, Role } from "../../../utils/types";

export const choicesParameter = Object.values(AlertParemeter);

const parameterImpacts = Object.values(AlertParameterImpact).map(val => ({ id: val, name: val }));

const useStyles = makeStyles(theme => ({
  root: {
    padding: "1.5em"
  },
  marginVertical: {
    marginTop: "1em",
    marginBottom: "2em"
  },
  pageFooter: {
    "& > button": {
      marginRight: theme.spacing(2)
    }
  }
}));

const AlertParameterCreate = props => {
  const dispatch = useDispatch();
  const [mutate, { loading }] = useMutation();
  const classes = useStyles();
  const { i18nKey, translate, basePath, roles, history } = props;

  const fields = ["parameter", "minusTolerance", "plusTolerance", "toleranceUnit", "desc"];
  const validationRule = {
    minusTolerance: { dataType: "number", maxValue: 0, required: false },
    plusTolerance: { dataType: "number", minValue: 0, required: false }
  };

  const formValues = useSelector(state => state.form["record-form"] && state.form["record-form"].values);

  const onSubmit = (rows, _, onSubmitComplete) => {
    let options = {
      url: "alert-parameters",
      method: "post",
      data: { ...formValues, alertParameterItems: rows }
    };
    mutate(options, {
      onSuccess: () => {
        dispatch(showNotification("js.notification.created", { resource: i18nKey }));
        props.history.push(basePath);
      }
    });
  };

  const columns = useDeepMemo(() => {
    return [
      { dataKey: "impact", title: "Impact", inputType: "select-input", choices: parameterImpacts, options: { style: { width: 160 } } },
      { dataKey: "reason", title: "Reason", inputType: "text-input", options: { style: { width: 600 } } }
    ];
  }, []);

  let ffHandleSubmit;
  const handleSubmitRef = submit => {
    ffHandleSubmit = submit;
  };

  if (!(roles?.includes(Role.MASTER) || roles?.includes(Role.SUPER_USER))) {
    return <Forbidden history={history} />;
  }

  return (
    <div className={classes.root}>
      <PageHeader title="resources.products.pageHeader.create" titleArgs={{ _: "Create Alert Parameter" }} />

      <WithReduxForm initialValues={{}}>
        {({ handleSubmit }) => (
          <div>
            <Card className={classes.marginVertical}>
              <CardContent>
                <Grid container spacing={2}>
                  {fields.includes(AlertParameterFields.PARAMETER) && (
                    <Grid item xs={12} sm={3}>
                      <SelectInput i18nKey={i18nKey} source="parameter" label="Parameter" choices={choicesParameter} {...inputOptions(3)} />
                    </Grid>
                  )}

                  {fields.includes(AlertParameterFields.MINUS_TOLERANCE) && (
                    <Grid item xs={12} sm={3}>
                      <NumberInput
                        i18nKey={i18nKey}
                        source="minusTolerance"
                        validate={getValidation(validationRule[AlertParameterFields.MINUS_TOLERANCE])}
                        {...inputOptions(3)}
                      />
                    </Grid>
                  )}

                  {fields.includes(AlertParameterFields.PLUS_TOLERANCE) && (
                    <Grid item xs={12} sm={3}>
                      <NumberInput
                        i18nKey={i18nKey}
                        source="plusTolerance"
                        validate={getValidation(validationRule[AlertParameterFields.PLUS_TOLERANCE])}
                        {...inputOptions(3)}
                      />
                    </Grid>
                  )}

                  {fields.includes(AlertParameterFields.TOLERANCE_UNIT) && (
                    <Grid item xs={12} sm={3}>
                      <TextInput
                        i18nKey={i18nKey}
                        source="toleranceUnit"
                        validate={getValidation(validationRule[AlertParameterFields.TOLERANCE_UNIT])}
                        {...inputOptions(3)}
                      />
                    </Grid>
                  )}

                  {fields.includes(AlertParameterFields.DESC) && (
                    <Grid item xs={12} sm={3}>
                      <TextInput
                        i18nKey={i18nKey}
                        source="desc"
                        validate={getValidation(validationRule[AlertParameterFields.DESC])}
                        {...inputOptions(3)}
                      />
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>

            <Card>
              <CardHeader title="Alert Reasons" />
              <Divider />
              <div>
                <MuiTable
                  columns={columns}
                  component="div"
                  editable
                  editing
                  showEditableActions
                  rowAddCount={1}
                  handleSubmitRef={handleSubmitRef}
                  onSubmit={onSubmit}
                />
              </div>
            </Card>

            <PageFooter className={classes.pageFooter}>
              <Button
                label={translate(`resources.products.button.save`, { _: "Save" })}
                color="primary"
                variant="contained"
                disabled={loading}
                onClick={event => {
                  handleSubmit(() => {})();
                  ffHandleSubmit(event);
                }}>
                {loading ? <CircularProgress size={20} thickness={2} /> : <SaveIcon />}
              </Button>
              <BackButton variant="contained" />
            </PageFooter>
          </div>
        )}
      </WithReduxForm>
    </div>
  );
};

export default translate(AlertParameterCreate);
